import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <h3>Ops! The page you're finding is not available.</h3>
        </div>
    );
};

export default NotFound;